import React from 'react';

function ComingSoon() {
  return <h1>Coming Soon</h1>;
}

export default ComingSoon;
